import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Tooltip,
  Select,
  Row,
  Col,
  Checkbox,
  Button,
  Spin,
  Modal,
  List,
  Typography,
  notification,
  Upload,
  message,
  Image,
  Radio,
} from "antd";
import { cfs } from "../../firebase/firebase";
import { validatePhone } from "../../utility/index";

const { Option } = Select;
const { Title, Paragraph, Text } = Typography;
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const Profile = ({ currentUser }: any) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(true);
  const [open, setOpen] = useState<boolean>(false);
  const [agreement, setAgreement] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (currentUser.merchantNameTH) {
      document.title = `${currentUser.merchantNameTH} | ${currentUser.merchantNameEN}`;
      form.setFieldsValue({
        ...form,
        ...currentUser,
        email: currentUser.email,
        currentBill: Number(currentUser.currentBill),
        tables: Number(currentUser.tables),
        phone: currentUser.phone,
      });
      setLoading(false);
    }
  }, [currentUser.merchantNameTH]);

  useEffect(() => {
    if (error) {
      notification.error({
        message: "เกิดข้อผิดพลาด",
        description: error,
        placement: "bottomRight",
        onClick: () => {
          setError("");
        },
        onClose: () => {
          setError("");
        },
      });
    }
  }, [error]);

  const onFinish = (values: any) => {
    console.log("Received values of form: ", values);

    if (
      Number(values.tables) >= 0 &&
      Number(values.currentBill) >= 0 &&
      Number.isInteger(Number(values.currentBill)) &&
      Number.isInteger(Number(values.tables))
    ) {
      setLoading(true);
      cfs
        .collection("merchants")
        .doc(`${currentUser.merchantId}`)
        .update({
          ...values,
          tables: Number(values.tables),
          currentBill: Number(values.currentBill),
        })
        .then((data) => {
          console.log("update data");
          setLoading(false);
          setAgreement(false);
          setError("");
        })
        .catch((err) => {
          setError("ไม่สามารถยืนยันตัวตน");
          setLoading(false);
        });
    } else {
      setError("ข้อมูลไม่ถูกต้อง");
    }
  };

  const policys: any = [
    {
      title: "เว็บไซต์ของระบบจัดการร้านค้าออลเดอร์",
      description:
        "ออลเดอร์ คอร์เปอเรชั่น จำกัด (“ผู้ให้บริการ”) เป็นเจ้าของและผู้ดูแลจัดการเว็บไซต์นี้ โดยมีวัตถุประสงค์เพื่อเป็นเว็บไซต์จัดการร้านค้า ดูยอดขายสินค้าของร้านค้า รวมทั้งเป็นแหล่งรวบรวม เผยแพร่ข้อมูลด้านต่าง ๆ ของผู้ให้บริการ และบริษัทในกลุ่มธุรกิจของผู้ให้บริการ อีกทั้งยังเป็นการอำนวยความสะดวกแก่ท่านในการใช้งานผลิตภัณฑ์และบริการต่าง ๆ ของผู้ให้บริการ",
    },
    {
      title: "เครื่องหมายการค้าและลิขสิทธิ์",
      description:
        "ให้บริการและ/หรือบริษัทในเครือเป็นเจ้าของลิขสิทธิ์ข้อมูล ภาพ ข้อความ สื่อโฆษณา และส่วนประกอบอื่น ๆ ที่อยู่บนเว็บไซต์นี้ เช่น เครื่องหมายการค้า สัญลักษณ์ เครื่องหมายบริการ และชื่อทางการค้า โดยห้ามมิให้ ทำซ้ำ คัดลอก ถ่ายสำเนา ดัดแปลง เผยแพร่ หรือกระทำการอื่นใด เพื่อเผยแพร่ต่อสาธารณชน หรือเพื่อหาประโยชน์ โดยไม่ได้รับการยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจากผู้ให้บริการกรุงเทพและ/หรือบริษัทในเครือ แล้วแต่กรณี",
    },
    {
      title: "ข้อมูลต่าง ๆ บนเว็บไซต์ของผู้ให้บริการ",
      description:
        "ผู้ให้บริการดูแลจัดการเว็บไซต์นี้ในประเทศไทย และมิได้ให้คำรับรองว่าข้อมูลที่จัดให้มีในหรือผ่านเว็บไซต์นี้ใช้ได้หรือเหมาะสมในการใช้ในประเทศอื่น ๆ หากท่านใช้เว็บไซต์นี้ในประเทศอื่น ๆ ท่านมีความรับผิดชอบในการปฏิบัติตามกฎหมายที่ใช้บังคับในประเทศนั้น\nเนื้อหาในส่วนใดส่วนหนึ่งหรือหน้าใดหน้าหนึ่งของเว็บไซต์นี้ อาจระบุข้อตกลงและเงื่อนไขการใช้บริการอื่นที่แยกออกไปต่างหาก ในกรณีที่ข้อตกลงและเงื่อนไขการใช้บริการอื่นและข้อตกลงและเงื่อนไขการใช้บริการนี้ มีความขัดแย้งกัน ให้ใช้ข้อตกลงและเงื่อนไขในการใช้บริการที่แยกออกไปนั้น โดยผู้ให้บริการขอแนะนำให้ท่านอ่านข้อตกลงและเงื่อนไขการใช้บริการอื่นนั้นก่อนใช้บริการนั้น ๆ\nผู้ให้บริการขอสงวนสิทธิในการนำเสนอ ปรับปรุงและแก้ไขข้อมูลที่ปรากฏบนเว็บไซต์ ซึ่งข้อมูลดังกล่าวได้ถูกจัดทำขึ้นโดยมิได้มีจุดประสงค์เพื่อการให้คำแนะนำอย่างผู้เชี่ยวชาญ\nทั้งนี้ ผู้ให้บริการไม่รับรองถึงความถูกต้อง และเป็นปัจจุบันของข้อมูลต่าง ๆ ในเว็บไซต์นี้",
    },
    {
      title: "การเชื่อมโยงเว็บไซต์ภายนอก",
      description:
        "เว็บไซต์ของผู้ให้บริการอาจจัดให้มีการเชื่อมต่อไปยังเว็บไซต์อื่น ๆ ซึ่งอยู่ภายใต้การดูแลของบุคคลที่สาม เพื่อวัตถุประสงค์ในการให้ข้อมูลและเพื่อความสะดวกของท่านเท่านั้น ผู้ให้บริการไม่สามารถรับประกันว่าข้อมูลในเว็บไซต์อื่น ๆ ดังกล่าวมีความถูกต้อง สมบูรณ์เพียงพอ เป็นปัจจุบัน เหมาะสมกับวัตถุประสงค์ใดโดยเฉพาะ และปราศจากไวรัส หรือ Malware ตลอดจนผู้ให้บริการไม่ต้องรับผิดต่อความสูญเสีย ความเสียหาย หรือค่าใช้จ่ายใด ๆ ที่เกิดขึ้น อันเป็นผลสืบเนื่องมาจากการที่ท่านเข้าใช้เว็บไซต์อื่น ๆ และผู้ให้บริการขอให้ลูกค้าทุกท่านศึกษารายละเอียดข้อกำหนดและเงื่อนไขในการใช้บริการของเว็บไซต์นั้น ๆ ก่อนที่ท่านจะเข้าใช้บริการ",
    },
    {
      title: "การจำกัดความรับผิดชอบ",
      description:
        "ผู้ให้บริการไม่รับผิดชอบต่อความเสียหาย ค่าใช้จ่าย หรือความสูญเสีย ที่อาจเกิดขึ้นจากการใช้เว็บไซต์ของผู้ให้บริการ หรือเว็บไซต์ที่เชื่อมโยงกับเว็บไซต์ผู้ให้บริการ ซึ่งรวมถึงจากความไม่ถูกต้องแม่นยำของข้อมูล ความล่าช้าในการถ่ายโอนข้อมูล ระยะเวลาในการเผยแพร่ข้อมูล เหตุขัดข้องหรืออุปสรรคของการเชื่อมต่อ ความผิดพลาดในการแสดงผล ความเสถียรของระบบ ไวรัสคอมพิวเตอร์",
    },
    {
      title: "กฎหมายที่ใช้บังคับ",
      description:
        "การใช้บริการเว็บไซต์นี้หรือการตีความข้อตกลงและเงื่อนไขการใช้บริการเว็บไซต์นี้ให้เป็นไปตามกฎหมายไทย",
    },
  ];

  return (
    <Spin tip="กำลังโหลดข้อมูล.." spinning={loading}>
      <div>
        <div className="site-card-wrapper">
          <Form
            {...formItemLayout}
            form={form}
            name="register"
            onFinish={onFinish}
            scrollToFirstError
          >
            <Form.Item
              name="email"
              label="อีเมล"
              labelCol={{ span: 4, offset: 0 }}
              wrapperCol={{ span: 20, offset: 0 }}
            >
              <Input disabled={true} />
            </Form.Item>

            <Form.Item
              labelCol={{ span: 4, offset: 0 }}
              wrapperCol={{ span: 20, offset: 0 }}
              name="merchantNameTH"
              label="ชื่อร้านภาษาไทย"
            >
              <Input disabled={true} />
            </Form.Item>

            <Form.Item
              labelCol={{ span: 4, offset: 0 }}
              wrapperCol={{ span: 20, offset: 0 }}
              name="merchantNameEN"
              label="ชื่อร้านภาษาอังกฤษ"
            >
              <Input disabled={true} />
            </Form.Item>

            <Form.Item
              labelCol={{ span: 4, offset: 0 }}
              wrapperCol={{ span: 20, offset: 0 }}
              name="paperSize"
              label="ขนาดกระดาษ"
            >
              <Radio.Group value={currentUser.paperSize}>
                <Radio.Button value="mm58">58 มิลลิเมตร</Radio.Button>
                <Radio.Button value="mm80">80 มิลลิเมตร</Radio.Button>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              labelCol={{ span: 4, offset: 0 }}
              wrapperCol={{ span: 20, offset: 0 }}
              name="currentBill"
              label="ลำดับบิลปัจจุบัน"
              // rules={[
              //   { message: "ระบุเป็นตัวเลข!" },
              //   ({ getFieldValue }) => ({
              //     validator(rule, value) {
              //       console.log("value :>> ", value);
              //       if (!value || Number(getFieldValue("currentBill")) >= 0) {
              //         return Promise.resolve();
              //       }
              //       return Promise.reject("ระบุเป็นตัวเลข!");
              //     },
              //   }),
              // ]}
            >
              <Input disabled={false} />
            </Form.Item>

            <Form.Item
              labelCol={{ span: 4, offset: 0 }}
              wrapperCol={{ span: 20, offset: 0 }}
              name="tables"
              label="จำนวนโต๊ะ"
              // rules={[
              //   { message: "ระบุเป็นตัวเลข!" },
              //   ({ getFieldValue }) => ({
              //     validator(rule, value) {
              //       console.log("value :>> ", value);
              //       // console.log(' Number(getFieldValue("tables")) :>> ',  Number(getFieldValue("tables")));
              //       if (!value || Number(getFieldValue("tables")) >= 0) {
              //         if (
              //           Number(getFieldValue("tables")) <= currentUser.maxTable
              //         ) {
              //           console.log("here1");
              //           return Promise.resolve();
              //         } else {
              //           console.log("here2");
              //           return Promise.reject(
              //             `ไม่สามารถเพิ่มโต๊ะเกิน ${currentUser.maxTable} โต๊ะ!`
              //           );
              //         }
              //       }

              //       console.log("here3");
              //       return Promise.reject("ระบุเป็นตัวเลข!");
              //     },
              //   }),
              // ]}
            >
              <Input disabled={false} />
            </Form.Item>

            <Form.Item
              labelCol={{ span: 4, offset: 0 }}
              wrapperCol={{ span: 20, offset: 0 }}
              name="phone"
              label="เบอร์โทร"
              rules={[
                { message: "เบอร์โทรไม่ถูกต้อง!" },
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (value && validatePhone(getFieldValue("phone"))) {
                      return Promise.resolve();
                    }

                    return Promise.reject("เบอร์โทรไม่ถูกต้อง!");
                  },
                }),
              ]}
            >
              <Input
                placeholder="0xx-xxxx-xxxx"
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>

            <Form.Item
              labelCol={{ span: 4, offset: 0 }}
              wrapperCol={{ span: 20, offset: 0 }}
              name="logoImg"
              label="ภาพโลโก้"
            >
              <Image
                width={100}
                height={100}
                alt="ภาพโลโก้"
                src={currentUser.logoImg}
                fallback="data:image/png;base64,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"
                style={{ cursor: "pointer", border: "solid 1px #d9d9d9" }}
              />
            </Form.Item>

            <Form.Item
              labelCol={{ span: 4, offset: 0 }}
              wrapperCol={{ span: 20, offset: 0 }}
              name="promptpayImg"
              label="ภาพพร้อมเพย์"
            >
              <Image
                width={100}
                height={100}
                alt="ภาพพร้อมเพย์"
                src={currentUser.promptpayImg}
                fallback="data:image/png;base64,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"
                style={{ cursor: "pointer", border: "solid 1px #d9d9d9" }}
              />
            </Form.Item>

            <Row gutter={[16, 16]}>
              <Col span={24} style={{ textAlign: "center" }}>
                <Checkbox
                  checked={agreement}
                  onChange={(e) => setAgreement(!agreement)}
                >
                  ฉันอ่าน{" "}
                </Checkbox>
                <a
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  ข้อตกลงและเงื่อนไขการใช้บริการ
                </a>
              </Col>
              <Col span={24} style={{ textAlign: "center" }}>
                <Button type="primary" htmlType="submit" disabled={!agreement}>
                  บันทึก
                </Button>
              </Col>
            </Row>
          </Form>

          <Modal
            title="ข้อตกลงและเงื่อนไขการใช้บริการ"
            visible={open}
            onOk={() => setOpen(false)}
            onCancel={() => setOpen(false)}
            footer={[
              <Button
                key="submit"
                type="primary"
                onClick={() => setOpen(false)}
              >
                ปิด
              </Button>,
            ]}
          >
            <Text type="warning">
              &nbsp;&nbsp;&nbsp; กรุณาอ่านข้อกำหนดและเงื่อนไขต่างๆ
              ดังต่อไปนี้อย่างละเอียด โดยในการเข้าถึงเว็บไซต์นี้ และหน้าจอใดๆ
              ของเว็บไซต์
              ถือว่าท่านตกลงที่จะผูกพันตามข้อกำหนดและเงื่อนไขการใช้บริการนี้
            </Text>
            {/* <Divider /> */}
            <List
              itemLayout="horizontal"
              dataSource={policys}
              renderItem={(item: any) => (
                <List.Item>
                  <List.Item.Meta
                    title={
                      <div>
                        <Title level={5}>{item.title}</Title>
                      </div>
                    }
                    description={
                      <Paragraph>
                        &nbsp;&nbsp;&nbsp;{item.description}
                      </Paragraph>
                    }
                  />
                </List.Item>
              )}
            />
          </Modal>
        </div>
      </div>
    </Spin>
  );
};

export default Profile;
